import React from 'react';
import {autorun} from 'mobx';
import {observer, inject, Observer} from 'mobx-react';
import 'react-day-picker/lib/style.css';

import {Route, Redirect, withRouter} from 'react-router';

import {VIEWS} from '../../model/const';

import {Home} from './Home';
import {Search} from './Search';
import {Detail} from './Detail';
import {BWOfferDetails} from './BWOfferDetails';
import {BWServices} from './BWServices';
import {BWAccessories} from './BWAccessories';
import {BWPersonalData} from './BWPersonalData';
import {BWReview} from './BWReview';
import {BWPayment} from './BWPayment';
//import {BWBookingSuccessful} from './BWBookingSuccessful';
import {BWFinished} from './BWFinished';
import {UserProfile} from './UserProfile';
import {ChooseLessor} from './ChooseLessor';
import {RecentBookingDetail} from './RecentBookingDetail';
import {RecentBookings} from './RecentBookings';
import {ForgottenPassword} from './ForgottenPassword';

const $ = window.$;

  /*$.scrollIt({
    easing: 'easeInOutBounce',
    topOffset: -0
  });*/

@inject(stores => ({
  //vMaster: stores.app.vMaster,
  router: stores.app.router,
}))
@observer
export class App extends React.Component {
  componentDidMount() {
    this.reScroll = autorun(() => {
      switch(this.props.router.currentViewPattern) {
        case VIEWS.search:
          return;
        default:
          window.scrollTo(0, 0);
          return;
      }
    })
  }

  componentWillUnmount() {
    this.reScroll();
  }

  getPageComponent(view, step) {
    switch(view) {
      case VIEWS.chooseLessor: 
        return <ChooseLessor />;
      case VIEWS.home:
        return <Home />
      case VIEWS.search:
        return <Search /> ;
      case VIEWS.objectDetails:
        return <Detail />;
      case VIEWS.bwOfferDetails:
        return <BWOfferDetails />;
      case VIEWS.bwServices:
        return <BWServices /> ;
      case VIEWS.bwAccessories:
        return <BWAccessories />;
      case VIEWS.bwPersonalData:
        return <BWPersonalData />;
      case VIEWS.bwReview:
        return <BWReview />;
      case VIEWS.bwPayment:
        return <BWPayment />;
      //case VIEWS.bwBookingSuccessful:
      //  return <BWBookingSuccessful />;
      case VIEWS.bwFinished:
        return <BWFinished />        
      case VIEWS.userProfile:
        return <UserProfile isRegistration={false} step={step}/>;
      case VIEWS.recentBookings:
        return <RecentBookings isRegistration={true} />;
      case VIEWS.recentBookingDetail:
        return <RecentBookingDetail isRegistration={true} />;
      case VIEWS.userRegistration:
        return <UserProfile isRegistration={true} step={step} />;
      case VIEWS.forgottenPassword:
        return <ForgottenPassword step={step} />;
      case VIEWS.confirmRegistration:
        return null;
      case VIEWS.confirmPasswordReset:
        return null;
      default:
        return <div>Unknown route.</div>;
    }
  }

  render() {
    const view = this.props.router.currentViewPattern;
    const step = this.props.router.currentViewStep;
    return (
      this.getPageComponent(view, step)
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/App.js